<template>
<div id="apptable" v-cloak>

    <b-card :header="header" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
        <div class="text-left">           

            <div class="my-1 row">
                <div class="col-md-3">
                    <b-form-input v-model="filter" placeholder="Cerca..." />
                </div>
                <div class="col-md-9 text-right">
                    <b-button style="margin:1px 0px 1px 2px;" size="md" variant="outline-secondary" @click.stop="exportCSV()">
                        Esporta CSV
                    </b-button>
                    <b-button v-if="getShowInserisci()" style="margin:1px 0px 1px 2px;" size="md" variant="outline-primary" @click.stop="insert()">
                        Inserisci
                    </b-button>
                </div>
            </div>

            <!-- Main table element -->
            <b-table responsive v-show="showtable" id="main-table" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" @filtered="onFiltered" empty-text="Non sono stati trovati record da visualizzare" empty-filtered-text="Non sono stati trovati record corrispondenti alla tua richiesta">
                <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="id" scope="row">{{row.value}}</template>
                        <template slot="eventoVis" scope="row">{{row.value}}</template>
                        <template slot="socioVis" scope="row">{{row.value}}</template>                        
                        <template slot="importo" scope="row">{{row.value}}</template> 
                        <template slot="datapagamento" scope="row">{{row.value | formatDate}}</template>       
                        <template slot="attivoVis" scope="row">{{row.value}}</template>
                        <template slot="note" scope="row">{{row.value | formatNote}}</template>
   
                        <template slot="modifica" scope="row">
                            <!-- We use click.stop here to prevent a 'row-clicked' event from also happening -->
                            <b-btn style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details(row.item,row.index,$event.target)">Modifica</b-btn>
                        </template>

            </b-table>

            <div class="row my-1">
                <div class="col-md-8 col-sm-12">
                    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
                </div>
                <div class="col-md-4 col-sm-12 text-right">
                    <b-form-fieldset horizontal label="Righe per pagina" :label-cols="6">
                        <b-form-select :options="pageOptions" v-model="perPage" />
                    </b-form-fieldset>
                </div>
            </div>
        </div>

        <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>

    </b-card>

    
</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria
} from '../util.js'

import {
    Socio
} from '../classes.js'

export default {
    name: 'apptable',
    data: function () {
        return {      
            id_socio: this.$route.params.id_socio || null, 
            id_evento: this.$route.params.id_evento || null, 
            id_partecipa: this.$route.params.id_partecipa || null,
            id_prenotazione: this.$route.params.id_prenotazione || null,    
            items: [],
            namespace: NAMESPACE,
            fields: {
                id: {
                    label: '#',
                    sortable: true
                },
                eventoVis: {
                    label: 'Evento',
                    sortable: true
                },
                socioVis: {
                    label: 'Socio',
                    sortable: true
                },
                importo: {
                    label: 'Importo €',
                    sortable: true
                },
                datapagamento: {
                    label: 'Data pagamento',
                    sortable: true
                },
                attivoVis: {
                    label: 'Attivo',
                    sortable: true
                },
                note: {
                    label: 'Note',
                    sortable: true
                },
                modifica: {
                    label: ' ',
                    'class': 'text-right'
                }
            },
            currentPage: 1,
            perPage: 10,
            pageOptions: [{
                text: 10,
                value: 10
            }, {
                text: 25,
                value: 25
            }, {
                text: 50,
                value: 50
            }],
            sortBy: null,
            sortDesc: false,
            filter: null,
            totalRowsFilter: null,
            modalDetails: {
                index: '',
                data: ''
            },
            error: '',
            showerror: false,
            showtable: false
        };
    },
    computed: {
        totalRows: {
            // getter
            get: function () {
                return this.totalRowsFilter || this.items.length || 0;
            },
            // setter
            set: function (newValue) {
                this.totalRowsFilter = newValue;
            }
        },
        header: {
            //'Pagamenti #' + id
            // getter
            get: function () {
                var aux = "Pagamenti";

                if(this.id_evento != null){
                    aux += " evento #" + this.id_evento;
                }

                if(this.id_socio != null){
                    aux += " - socio #" + this.id_socio;
                }

                if(this.id_prenotazione != null){
                    aux += ' - prenotazione #' + this.id_prenotazione;
                }
                if(this.id_partecipa != null){
                    aux += ' - partecipazione #' + this.id_partecipa;
                }

                return aux;
            },
            // setter
            set: function (newValue) {

            }
        }
    },
    methods: {
        getShowInserisci(){

            /*
            return (this.id_socio != null && this.id_evento == null && this.id_partecipa == null && this.id_prenotazione == null) || 
                   (this.id_socio != null && this.id_evento != null && (this.id_partecipa != null || this.id_prenotazione != null));
            */

            //per ora si fanno inserire solo per gli eventi i pagamenti
            return (this.id_socio != null && this.id_evento != null && (this.id_partecipa != null || this.id_prenotazione != null));       


        },
        exportCSV() {

            if (this.items.length > 0) {
                //var str = '"#";"Note";"Data pagamento";"Data inizio evento";"Data fine evento";"Socio";"Evento";"Importo €"\r\n';
                var str = '"#";"Evento";"Socio";"Importo €";"Data pagamento";"Attivo";"Note"\r\n';
                for (var i = 0; i < this.items.length; i++) {
                    str += '"' + this.items[i].id + '"' + ";";
                    str += '"' + this.items[i].eventoVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].socioVis.replace(/\"/g, "\"\"") + '"' + ";";
                    str += '"' + this.items[i].importo + '"' + ";";
                    str += '"' + this.$options.filters.formatDate(this.items[i].datapagamento) + '"' + ";"; 
                    str += '"' + (this.items[i].flgatt == 'S' ? 'Sì' : 'No') + '"' + ";"; 
                    str += '"' + this.items[i].note.replace(/\"/g, "\"\"") + '"' + "\r\n"; 
                }

                var a = document.createElement('a');
                var blob = new Blob([str], {
                    'type': 'application\/octet-stream'
                });

                a.href = window.URL.createObjectURL(blob);
                a.download = 'pagamenti_' + moment(String(new Date())).format('YYYYMMDD_HHmmss') + '.csv';
                document.body.appendChild(a);
                a.click();
                setTimeout(function() {
                    document.body.removeChild(a);
                }, 100);

            }

        },
        insert() {   

            this.$router.push('/app/dettagliopagamento' + 
                (this.id_evento == null ? '' : '/id_evento/' + this.id_evento) + 
                (this.id_socio == null ? '' : '/id_socio/' + this.id_socio) + 
                (this.id_partecipa == null ? '' : '/id_partecipa/' + this.id_partecipa) + 
                (this.id_prenotazione == null ? '' : '/id_prenotazione/' + this.id_prenotazione) 
            );
            
        },
        details(item, index, button) {

            this.$router.push('/app/dettagliopagamento/' + item.id);

        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
    },
    filters: {
        formatDate: function(value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY');
        },
        formatDateTime: function (value) {
            if (!value) return '';
            return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
        },
        formatNote: function(value) {
            var numChar = 150;
            if (!value) return '';
            return value.substr(0, numChar) + (value.length <= numChar ? '' : ' ...');
        }
    },
    created: function () {

        

        if(!ctrlVismenu("P")){
            this.$router.replace('/accessdenied');
            return;
        }


        var token = localStorage.getItem('token');
        this.axios.get(NAMESPACE + 'rest/pagamenti/id_evento/' + this.id_evento + '/id_socio/' + this.id_socio + '/id_prenotazione/' + this.id_prenotazione + '/id_partecipa/' + this.id_partecipa, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                // JSON responses are automatically parsed.
                try {

                    if (!response.data.error) {

                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                        this.items = response.data.message;
                        let apptable = this;

                        apptable.items.forEach(function(element, index) {

                                element.datainizio_ric = apptable.$options.filters.formatDate(element.datainizio);
                                element.datafine_ric = apptable.$options.filters.formatDate(element.datafine);
                                element.socioVis = element.cognomesocio + " " + element.nomesocio;
                                element.eventoVis = element.titoloevento;
                                element.attivoVis = (element.flgatt == 'S' ? 'Sì' : 'No');

                                delete element.uteins; //per motivi di ricerca

                            });

                        apptable.items = apptable.items.filter(function (element) { 
                            
                            //per ora dovrebbero essere solo eventi
                            if((element.titoloevento || '') != ''){
                                return ctrlViscategoria(element.id_categoriaevento);
                            }
                            else if((element.nominativoimpianto || '') != ''){
                                return ctrlViscategoria(element.id_categoriaimpianto);
                            }
                            
                            return true;
                        });     

                        this.showtable = true;

                    } else {
                        throw new Error(response.data.message);
                    }

                } catch (e) {
                    this.showerror = true;
                    this.error = "Errore: " + e.message;
                }

            })
            .catch(e => {
                this.showerror = true;
                this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
            });

    }
}
</script>
